import { useEffect, useState } from "react";
import { db } from "../../../firebase";
import { useAuth } from "../../../hooks/useAuth";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { getEffectiveReminder } from "../data/usHolidayPresets.js";

export function useReminders(gifteeId) {
  const { currentUser } = useAuth();
  const [reminders, setReminders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentUser || !gifteeId) {
      setReminders([]);
      setLoading(false);
      return;
    }

    const col = collection(
      db,
      "users",
      currentUser.uid,
      "giftees",
      gifteeId,
      "reminders"
    );
    const q = query(col, orderBy("date", "asc"));

    const unsub = onSnapshot(
      q,
      (snap) => {
        setReminders(
          snap.docs.map((d) => getEffectiveReminder({ id: d.id, ...d.data() })),
        );
        setLoading(false);
      },
      (err) => {
        console.error("useReminders error:", err);
        setError("Failed to load reminders.");
        setLoading(false);
      }
    );

    return () => unsub();
  }, [currentUser, gifteeId]);

  return { reminders, loading, error };
}
